import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import * as ROUTE from "../index";

import scrollToTop from "../../libs/scrollToTop";

//route
import SideBarProfileContainer from "../../containers/profile/sideBar";
import UserChangeInfContainer from "../../containers/profile/changeInf";
// import UserPoint from "../../containers/profile/point/userPointPage";
import MainProfile from "../../containers/profile/mainProfile";
import UserReportList from "../../containers/profile/report";
import UserFinancialList from "../../containers/profile/financial/list";
import ErrorPage from "../../components/public/error";
import UserExperimentContainer from "../../containers/profile/experiment";
import UserMessagesContainer from "../../containers/profile/messages";
import UserChangePassContainer from "../../containers/profile/changePass";
import UserWalletContainer from "../../containers/profile/wallet/UserWalletContainer";
import UserWalletWithdrawContainer from "../../containers/profile/wallet/withdraw";
import UserReferralContainer from "../../containers/profile/referral";
import UserWalletDepositContainer from "../../containers/profile/wallet/deposit";
import UserReferralDetailContainer from "../../containers/profile/referral/userReferralDetailContainer";

import UserFinancialDetailContainer from "../../containers/profile/financial/detail";
import UserTokenDetailContainer from "../../containers/profile/financial/tokens";

import { ContainerRoute } from "./styledProfile";

const ProfileRouter = () => {
  const userRole = useSelector((state) => state.userDetail.userRole);
  const userRoleRoute =
    userRole === "student" ? ROUTE.ROUTE_STUDENT : ROUTE.ROUTE_TEACHER;

  useEffect(() => {
    scrollToTop();
  }, []);

  const routesArr = [
    {
      path: ROUTE.ROUTE_MY_WALLET,
      component: UserWalletContainer,
    },
    {
      path: ROUTE.ROUTE_MY_WALLET_DEPOSIT,
      component: UserWalletDepositContainer,
    },
    {
      path: ROUTE.ROUTE_MY_WALLET_WITHDRAW,
      component: UserWalletWithdrawContainer,
    },
    {
      path: ROUTE.ROUTE_MY_PROFILE,
      component: MainProfile,
    },
    {
      path: ROUTE.ROUTE_MY_EXPERIMENT,
      component: UserExperimentContainer,
    },
    {
      path: ROUTE.ROUTE_CHANGE_USER_INF,
      component: UserChangeInfContainer,
    },
    {
      path: ROUTE.ROUTE_CHANGE_USER_PASS,
      component: UserChangePassContainer,
    },
    // { //TODO: #Future feature
    //   path: ROUTE.ROUTE_MY_POINT,
    //   component: UserPoint,
    // },
    {
      path: ROUTE.ROUTE_MY_MESSAGE_LIST,
      component: UserMessagesContainer,
    },
    {
      path: ROUTE.ROUTE_MY_REPORT_LIST,
      component: UserReportList,
    },
    {
      path: ROUTE.ROUTE_MY_FINANCIAL_LIST,
      component: UserFinancialList,
    },
    {
      path: ROUTE.ROUTE_FINANCIAL_DETAIL_ID,
      component: UserFinancialDetailContainer,
    },
    {
      path: ROUTE.ROUTE_TOKEN_DETAIL_ID,
      component: UserTokenDetailContainer,
    },
    {
      path: ROUTE.ROUTE_REFERRAL,
      component: UserReferralContainer,
    },
    {
      path: ROUTE.ROUTE_REFERRAL_DETAIL,
      component: UserReferralDetailContainer,
    },
    {
      path: ROUTE.ROUTE_ERROR_PAGE,
      component: ErrorPage,
      global: true,
    },
  ];

  return (
    <ContainerRoute>
      <SideBarProfileContainer />
      <div className="col-12 col-sm-8">
        <Switch>
          {routesArr.map((item, index) => {
            return (
              <Route
                key={index}
                exact
                path={item.global ? item.path : `${userRoleRoute}/${item.path}`}
              >
                <item.component />
              </Route>
            );
          })}
        </Switch>
        {/*  /!* factor detail route in app.js *!/*/}
      </div>
    </ContainerRoute>
  );
};

export default ProfileRouter;
